import { render, staticRenderFns } from "./ChallengeCustomerModal.vue?vue&type=template&id=00b1e5d2"
import script from "./ChallengeCustomerModal.vue?vue&type=script&lang=js"
export * from "./ChallengeCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports